export const DEFAULT_OCCUPANCY = {
  unitCount: 1,
  occupancies: [
    {
      adults: 2,
      childrenAges: []
    }
  ]
};

export const DEFAULT_SEARCH_RADIUS = 4; // Default search radius in km

export const DEFAULT_LOCATION = {
  destination: 'San Francisco',
  lat: 37.7749,
  lng: -122.4194 // Default to San Francisco coordinates
};

export const QUERY_PARAM_KEYS = {
  startDate: 'startDate',
  endDate: 'endDate',
  destination: 'destination',
  lat: 'lat',
  lng: 'lng',
  radius: 'radius',
  rooms: 'rooms'
};
